/**
 * @module builder
 */
import type { QuoteDocument } from 'paintscout'
import type { Contact } from '@paintscout/api'
// Set secondary contact, or remove if not provided
export const setSecondaryContact = (args: {
  quote: QuoteDocument
  secondaryContact?: Partial<Contact>
}): QuoteDocument => {
  const { quote, secondaryContact } = args
  if (secondaryContact) {
    const { _id, _rev, ...contactInfo } = secondaryContact

    return {
      ...quote,
      secondaryContact: {
        ...contactInfo,
        id: _id,
        rev: _rev
      }
    }
  } else {
    delete quote.secondaryContact
    quote.billingSecondary = false
    return quote
  }
}
